import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { resolvePollingInterval } from '@omnea-app/frontend/utils/react-query/resolvePollingInterval'
import { throwIfApiError } from '@omnea-app/legacy/utils/error-handling/throwifApiError'
import { GetRequestFormsResponse } from '@omnea-app/requests/requestsFrontendClient'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const requestFormsQueryKey = 'requestForms'

interface UseGetRequestFormsOptions<TData = GetRequestFormsResponse> {
  refetchInterval?: number
  skip?: boolean
  select?: (data: GetRequestFormsResponse) => TData
}

export const useGetRequestForms = <TData = GetRequestFormsResponse>(
  { requestId }: { requestId: string },
  options?: UseGetRequestFormsOptions<TData>
) => {
  const { getToken } = useAuthenticatedUser()
  return useQuery({
    queryKey: [requestFormsQueryKey, requestId],
    enabled: !options?.skip,
    refetchInterval: (query) => resolvePollingInterval(query.state.error, options?.refetchInterval),
    select: options?.select,
    queryFn: async () => {
      const authorization = await getToken()
      const requestsClient = new RequestsHttpClient({ authorization })
      const { data, error } = await requestsClient.GET('/request-forms/{requestId}', {
        params: { path: { requestId } },
      })
      throwIfApiError(error)
      // only for enums
      return data as GetRequestFormsResponse
    },
  })
}
